import React from "react";

// import blogImg from "../assets/blog-image-1.jpg"; // Replace with your actual image path

const iconStyle = {
  backgroundColor: "rgb(4,180,228)",
  color: "white",
  width: "40px",
  height: "40px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  fontSize: "18px",
  textDecoration: "none"
};

const BlogPostCard = (props) => {
  return (
    <div className=" my-5 text-start" style={{ maxWidth: "800px" }}>
      {/* Image */}
      {props.upImage && (
        <img
          src={props.upImage}
          alt="Blog"
          className="img-fluid mb-4"
          style={{ borderRadius: "5px", width: "100%" }}
        />
      )}


      {/* Blog Category and Tags */}
      <p className="text-uppercase fw-semibold" style={{ color: "#29aae3" }}>
        <span style={{ borderTop: "2px solid #29aae3", paddingTop: "5px", display: "inline-block" }}>
          {props.smallHeading}
        </span>
      </p>

      {/* Title */}
      <h2 className="fw-bold mb-3" style={{ color: "#29aae3" }}>
        {props.largeHeading}
      </h2>

      {/* Date and Author */}
      <p className="text-muted mb-4" style={{ fontSize: "14px" }}>
        {props.date} / <span className="text-dark fw-medium">By {props.author}</span>
      </p>

      {/* Short Description */}
      <p className="text-dark" style={{ lineHeight: "1.7" }}>
        {props.description}
      </p>

      {/* Social icons and button */}
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div className="d-flex gap-2">
          {/* Facebook */}
          <a href="https://www.facebook.com/waralstechnology/" style={iconStyle}>
            <i className="bi bi-facebook"></i>
          </a>

          {/* X (Twitter) */}
          <a href="https://x.com/WaralsT" style={iconStyle}>
            <i className="bi bi-twitter-x"></i>
          </a>

          {/* LinkedIn */}
          <a href="https://www.linkedin.com/company/waralstechnology" style={iconStyle}>
            <i className="bi bi-linkedin"></i>
          </a>
        </div>
     <a href={props.link}><button className="btn border-primary  btn-outline-primary">
          Read More &nbsp; →
        </button></a> 
      </div>
      <hr></hr>
    </div>
  );
};

export default BlogPostCard;
